<template>
	<div class="pa-4">
		<v-card elevation="0">
			<v-card-title>
				<v-icon class="mr-2"> mdi-plus </v-icon>
				Soumettre un audit
			</v-card-title>
			<v-card-text>
				<v-form @submit.prevent="submit">
					<v-select
						:items="installations"
						item-value="id"
						item-text="name"
						v-model="installation"
            @change="onInstallChange"
						outlined
						dense
					></v-select>

					<v-row v-for="input in inputs" :key="input.key">
            <v-col cols="12" v-if="input.uploaded_file_names && showField(input)">
              Fichier(s) existant(s) : <br>
            </v-col>
						<v-col cols="12" v-for="file in input.uploaded_file_names" :key="file">
              <a
                v-if="showField(input)"
                :href="file"
                target="_blank"
                @click.prevent="getFileRepo(file)">
                {{file}}
              </a>
              <a
                v-if="showField(input)"
                :href="file"
                @click.prevent="delete_file(file)"
              >
                <v-icon color="red">
                  mdi-delete
                </v-icon>
              </a>
						</v-col>

						<v-col v-if="showField(input)" cols="10" md="11">
							<v-file-input
								:label="input.label"
								:multiple="input.multiple"
								outlined
								dense
								required
								v-model="form[input.key]"
							/>
						</v-col>

						<v-col v-if="showField(input)" cols="2" md="1">
							<v-btn
								elevation="0"
								color="blue white--text"
								:disabled="!form[input.key]"
                @click.prevent="uploadFile(input.key)"
              >
								Charger
							</v-btn>
						</v-col>
					</v-row>

					<v-row>
						<v-col cols="6">
							<v-btn
                v-if="isAdmin"
								elevation="0"
								color="red white--text"
								type="button"
								style="width: 100%"
								:disabled="!isConfigLoaded"
								@click.prevent="reset"
							>
								Réinitialiser le dépôt
							</v-btn>
						</v-col>
						<v-col cols="6">
							<v-btn
								elevation="0"
								color="blue white--text"
								type="submit"
								style="width: 100%"
								:disabled="!canSubmit"
							>
                {{ submitTypeDesc }}
							</v-btn>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
		</v-card>

    <!-- Notifications -->
    <v-snackbar
      v-model="notif_bar"
      :color="notif_color"
      :timeout="timeout"
    >
      {{ notif_text }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="black"
          text
          v-bind="attrs"
          @click="notif_bar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <!-- Dialog : Confirm remove file -->
    <v-dialog
      v-model="dialog"
      persistent
      max-width="350"
    >
      <v-card>
        <v-card-title class="text-h6">
          Supprimer un fichier
        </v-card-title>
        <v-card-text>Etes-vous certain de vouloir supprimer ce fichier du repository ?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue"
            @click="dialog = false"
          >
            Annuler
          </v-btn>
          <v-btn
            color="red"
            @click.prevent="removeFileRepo"
          >
            Supprimer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
	</div>
</template>

<script>
import api from "@/api/api.js";
import webconf from "../../utils/frontend_setup";


export default {
	data() {
		return {
      script_name: "Create.vue (Submit Audit)",        // For debug
      isAdmin: this.getRole() === 'admin',
      dialog: false,
      fileToRemove: null,
      neverSubmitted: true,
      notif_bar: false,
      notif_color: "black",
      notif_text: "",
      timeout: 5000,
			repository: null,
      nbFileSubmited: 0,
			installation: null,
      submitTypeDesc: "Soumettre l'audit",
			uploaded_files_list: [],
			form: {
				config: null,
				production: null,
				meteo: null,
				guid: null,
			},
		};
	},
	computed: {
		canSubmit() {
			if(this.installation) return (this.form.config || this.form.production || this.form.meteo) && this.neverSubmitted
			else return this.form.config && this.form.production && this.form.meteo && this.neverSubmitted
		},

		isConfigLoaded() {
			return !!this.form.guid;
		},

		inputs() {
			const inputs = [
				{
					uploaded_file_names: this.getFileNamesFromUploadedFilesList('config_site'),
					key: "config",
					label: "Configuration d'installation",
					conf_type: "configuration installation (.xlsm)",
					active: true,
					multiple: false,
          needAdmin: false,
				},
        {
					uploaded_file_names: this.getFileNamesFromUploadedFilesList('analysis'),
					key: "analysis",
					label: "Paramètres d'analyse",
					conf_type: "analysis parameters (.xlsx)",
					active: this.isConfigLoaded,
					multiple: false,
          needAdmin: true,
				},
				{
					uploaded_file_names: this.getFileNamesFromUploadedFilesList('pv_data'),
					key: "production",
					label: "Données de production",
					conf_type: "pv-data (.xlsx)",
					active: this.isConfigLoaded,
					multiple: false,
          needAdmin: false,
				},
				{
					uploaded_file_names: this.getFileNamesFromUploadedFilesList('std_meteo'),
					key: "meteo",
					label: "Données météo",
					conf_type: "Météo standard (.xlsx)",
					active: this.isConfigLoaded,
					multiple: false,
          needAdmin: false,
				},
			];

			return inputs.filter((i) => i.active);
		},

    installations() {
      function compare(a, b) {
        if ( a.name < b.name ) return -1;
        if ( a.name > b.name ) return 1;
        return 0;
      }

      let installations = [{
				id: null,
				name: "Nouvel audit",
			}];

      let existing_installations = [];

      this.$store.getters.installations.forEach(elm => {
        existing_installations.push({
          "id": elm.installation_id,
          "name": elm.installation_name
        });
      });
      existing_installations = existing_installations.sort(compare)
      installations = installations.concat(existing_installations)

      return installations
    }

	},

	watch: {
		installation(val) {
			this.resetState()

			if(val) {
				this.form.guid = this.repository.find(i => i.installation_id === val).uuid

        webconf.debugLog('watch', this.script_name,'installation : this.form.guid',
          this.form.guid
        )

				api.getRepositoryUploadedFilesList(this.form.guid)
					.then(res => {
            this.uploaded_files_list = res.data.file_source
            this.fileToRemove = null
            this.nbFileSubmited = 0
          })
			}
		}
	},

	mounted() {
		api.getRepository().then(res => this.repository = res.data)
    this.installationList()
    this.nbFileSubmited = 0
	},

	methods: {
		installationList() {
      this.$store
				.dispatch("getInstallationList")
				.then(async () => {
        });
		},

    showField(val) {
      if (val.needAdmin) {
        return this.isAdmin;
      } else {
        return true
      }
    },

    getRole() {
      return this.$store.state.authStore.role
    },

    delete_file(val) {
      if (val) {
        this.fileToRemove = val
        this.dialog = true
      }
    },

    async removeFileRepo() {
      this.dialog = false

      await api
        .removeFileRepository(this.form.guid, this.fileToRemove)
        .then(() => {
          api.getRepositoryUploadedFilesList(this.form.guid)
            .then(res => {
              this.uploaded_files_list = res.data.file_source
              this.fileToRemove = null
              this.nbFileSubmited = 0
            })
        })
        .catch(console.error)
    },

    async getFileRepo(filename) {
      await api
        .getFileRepository(this.form.guid, `/input/${filename}`, 'application/vnd.ms-excel;charset=UTF-8')
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        }).catch(console.error)
    },

		getFileNamesFromUploadedFilesList(key) {
			if(!this.uploaded_files_list || !Object.keys(this.uploaded_files_list).length) return false

      if (this.uploaded_files_list[key] && Object.values(this.uploaded_files_list[key]).length) {
        return Object.values(this.uploaded_files_list[key])
      } else {
        return false
      }
		},

    onInstallChange(value) {
      webconf.debugLog('methods', this.script_name,'onInstallChange : value',
          value
      )
      this.neverSubmitted = true

      if (value === null) {
        this.submitTypeDesc = "Soumettre l'audit"
      } else {
        this.submitTypeDesc = "Mettre à jour l'audit"
      }
    },

		reset() {
			api.resetAudit(this.form.guid).then(
				() => {
          this.resetState();
          this.notif_text = "Le dépôt de fichier a été réinitialisé";
          this.notif_color = "red";
          this.notif_bar = true;
          this.nbFileSubmited = 0;
        });
		},

		resetState() {
			this.uploaded_files_list = null
			this.form = {
				config: null,
				production: null,
				meteo: null,
				guid: null,
			}
		},

		uploadFile(key) {
			const conf_type = this.inputs.find((i) => i.key === key)?.conf_type;
			api.uploadFile(this.form[key], conf_type, this.form.guid).then((res) => {
				if (!this.isConfigLoaded) this.form.guid = res.data.guid;

        this.notif_text = "Le fichier a été chargé sur dans le dépôt"
        this.notif_color = "#77c27a"
        this.notif_bar = true

        api.getRepositoryUploadedFilesList(this.form.guid)
					.then(res => {
            this.uploaded_files_list = res.data.file_source
            this.nbFileSubmited += 1
            this.fileToRemove = null
          })
			});
		},

		submit() {
      let user_mail = ""
      this.neverSubmitted = false

      if (this.submitTypeDesc === "Soumettre l'audit") {
      api
        .currentUser()
        .then((res) => {
          user_mail = res['data']['email'];

          api
            .storeAudit(this.form.guid, user_mail)
            .then(() => {
              this.notif_text = "Heliocity a bien reçu les fichiers de configuration"
              this.notif_color = "#77c27a"
              this.notif_bar = true
              this.nbFileSubmited = 0
              new Promise(r => setTimeout(r, 3000))
              this.$store.dispatch('getInstallationList').then(() => this.$router.push("/dashboard-audits"))
            })
            .catch(() => {
              alert(
                `Erreur, veuillez contacter le support d'Heliocity.\nCode guid : ${this.form.guid}`
              );
            });
        });
      } else {
        this.notif_text = "Heliocity a bien reçu les mises à jours"
        this.notif_color = "#77c27a"
        this.notif_bar = true
        this.nbFileSubmited = 0
      }
		},
	},
};
</script>